import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams } from 'ionic-angular'

import { TabCallsPage } from '../tab-calls/tab-calls'
import { TabMessagesPage } from '../tab-messages/tab-messages'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-history',
	templateUrl: 'history.html',
})
export class HistoryPage {
	tabCalls = TabCallsPage;
	tabMessages = TabMessagesPage;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams) {
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	ionViewDidLoad() {
		//console.log('ionViewDidLoad HistoryPage');
	}
}



// WEBPACK FOOTER //
// ./src/pages/history/history.ts